import ModelUtil from '@leverege/model-util';
import { Attributes } from '@leverege/ui-attributes';
const TYPE = 'recovr.colorizer.Environment';
function create() {
  return {
    type: TYPE,
    attributeName: 'environment',
    unsetColor: '#1661D7',
    indoorColor: '#DBEDE7',
    outdoorColor: '#1661D7'
  };
}
const common = {
  ...ModelUtil.createAllValue('indoorColor'),
  ...ModelUtil.createAllValue('outdoorColor'),
  ...ModelUtil.createAllValue('unsetColor')
};
function colorFor(model, obj, context) {
  const environment = Attributes.get(model.attributeName, obj);
  if (environment === 'indoors') {
    return common.getIndoorColor(model);
  }
  if (environment === 'outdoors') {
    return common.getOutdoorColor(model);
  }
  return common.getUnsetColor(model);
}
export default {
  TYPE,
  create,
  ...common,
  colorFor
};